import { useState } from "react"

import { Button, Col, Modal, ModalBody, ModalTitle, Row } from "react-bootstrap"
import ModalHeader from "react-bootstrap/esm/ModalHeader"
import { toast } from "react-toastify"
import { finalize } from "rxjs/operators"

import FormatError from "../../../formatters/FormatError"
import { DraggableModalDialog } from "../../Randomization/GovPools/RandomSchedulingExclusionsModal"
import SearchBar from "../../SearchBar"
import { CompletedMatchingTest, PoolSelectionTestMatchObservable } from "../../../api/Randoms/PoolSelectionActions"
import ActionButton from "../../ActionButton"
import CompletedTests from "./CompletedTests"
import ConfirmationModal from "../../ConfirmationModal"


interface CompleteRandomSelectionProps {
  testDetailID: number
  testTypeID: number
  poolSelectionID: number
  onClose: (withUpdate: boolean) => void
}

const searchFields = [
  { Name: "SampleID" },
  { Name: "All Personnel IDs" },
  { Name: "SSN" },
  { Name: "Employer ID" },
  { Name: "Driver ID" },
  { Name: "Alternate ID" },
  { Name: "First Name" },
  { Name: "Last Name" },
  //{ Name: "Company" },
  //{ Name: "Location" },
].map((el) => {
  return { Name: el.Name, ID: el.Name }
})

function CompleteRandomSelection(props: CompleteRandomSelectionProps) {
  const { testDetailID, testTypeID, poolSelectionID, onClose } = props

  const [Search, setSearch] = useState({ field: "", text: "" })
  const [selectedTest, setSelectedTest] = useState<CompletedMatchingTest>()
  const [acceptProc, setAcceptProc] = useState(false)
  const [confirmSave, setConfirmSave] = useState(false)

  const onCancel = () => {
    onClose(false)
  }

  const onSave = () => {
    setAcceptProc(true)
    setConfirmSave(false)
    const acceptOptions = {
      TestDetailID: testDetailID,
      CompletedTestDetailID: selectedTest?.TestDetailID || 0,
      HasError: selectedTest?.HasError || false
    }
    PoolSelectionTestMatchObservable(acceptOptions)
      .pipe(finalize(() => setAcceptProc(false)))
      .subscribe(
        (data) => {
          toast.success(data)
          onClose(true)
        },
        (error) => toast.error(FormatError(error))
      )
  }

  const onAccept = () => {
    setConfirmSave(true)
  }

  const onCancelConfirm = () => {
    setConfirmSave(false)
  }

  const handleSearch = (field: string, text: string) => {
    setSelectedTest(undefined)
    setSearch({ field, text })
  }

  return (<>
    <Modal dialogAs={DraggableModalDialog} backdrop="static" show size="xl" dialogClassName="dark" onHide={onClose}>
      <ModalHeader closeButton>
        <ModalTitle>Complete A Random Selection</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            Search for test to match from Selection List:
          </Col>
        </Row>
        <Row className="my-3">
          <Col>
            <SearchBar onSearch={handleSearch} searchFields={searchFields} placeholder="All Personnel IDs" />
          </Col>
        </Row>
        <Row>
          <Col>
            <CompletedTests
              search={Search}
              poolSelectionID={poolSelectionID}
              testDetailID={testDetailID}
              testTypeID={testTypeID}
              selectedTest={selectedTest}
              onSelectTest={setSelectedTest}
            />
          </Col>
        </Row>
      </ModalBody>
      <Modal.Footer>
        <Button variant="primary" onClick={onCancel}>Cancel</Button>
        <ActionButton
          variant="secondary"
          onClick={onAccept}
          disabled={!selectedTest}
          spin={acceptProc}
        >
          Accept
        </ActionButton>
      </Modal.Footer>
    </Modal>
    <ConfirmationModal show={confirmSave}
        title="CONFIRM"
        textTitle="This update could not be reverted. Are you sure?"
        text=""
        showCancelButton={true}
        showImage={false}
        confirmButtonText="OK"
        onConfirm={onSave}
        onHide={onCancelConfirm} />
    </>
  )
}

export default CompleteRandomSelection
